import { mainPath } from "../../../lib/mainPath";
import { requestsTemplates } from "../../../lib/requestsTemplates";

export const get = (scopeStringId, params) =>
  requestsTemplates.get(
    mainPath,
    `/bitrix/${scopeStringId}/fields`,
    params
  );
